import { RootState } from '../store'

export const selectIsAuthenticated = (state: RootState) => state.auth.isAuthenticated
export const selectUser = (state: RootState) => state.auth.user
export const selectTokens = (state: RootState) => state.auth.tokens
export const selectAuthLoading = (state: RootState) => state.auth.loading
export const selectAuthError = (state: RootState) => state.auth.error
export const selectUserRole = (state: RootState) => state.auth.userRole

export const selectUserTeamMemberInfo = (state: RootState) => state.auth.user?.teamMemberInfo
export const selectUserGoogleInfo = (state: RootState) => state.auth.user?.googleUserInfo
